<template>
    <div class="sign-up-partner">
        <div
            v-if="isLoadingDone && (hasLogo || hasPartner)"
            class="sign-up-partner__content"
            :class="{
        'sign-up-partner__content--gray': isDesktop,
        'sign-up-partner__content--white': !isDesktop
      }"
        >
            <div class="sign-up-partner__content-partner">
                <p class="sign-up-partner__content-partner-label">Vantagem exclusiva</p>
                <img v-if="hasLogo" :src="logo" class="sign-up-partner__content-partner-logo"/>
                <h2 v-else-if="hasPartner" class="sign-up-partner__content-partner-name">{{ partnerName }}</h2>
            </div>
        </div>
    </div>
</template>

<script>
import {computed, defineComponent} from 'vue'

import {useStore} from "@/store/store.js"
import imgLogoFiloo from "@/assets/images/logo.png"
import imgBanner from "@/assets/images/SignUp/banner.jpeg"

export default defineComponent({
    name: "SignUpPartner",

    props: {
        loadingDone: {
            type: Boolean,
            default: false
        },
        logo: {
            type: String,
            default: ''
        },
        partner: {
            type: Object,
            default: () => ({})
        }
    },

    setup() {
        const store = useStore()

        return {
            device: computed(() => store.getters.device),
            imgLogoFiloo,
            imgBanner,
        }
    },

    computed: {
        isDesktop() {
            return this.device === 'desktop'
        },
        hasLogo() {
            return !!this.logo
        },
        hasPartner() {
            return !!this.partner
        },
        partnerName() {
            return this.partner?.name || ''
        }
    },

    data() {
        return {
            isLoadingDone: false
        }
    },

    watch: {
        loadingDone(val) {
            if (val) {
                setTimeout(() => this.isLoadingDone = val, 500)
            } else {
                this.isLoadingDone = val
            }
        }
    }
})
</script>

<style lang="scss" scoped>
.sign-up-partner {
    $this: &;

    &__content {
        border-radius: .5rem;
        padding: .75rem;
        width: 100%;

        &:not(:first-child) {
            margin-top: 1rem;
        }

        &--gray {
            background-color: #F0F1F2;
        }

        &--white {
            background-color: #FFF;
        }

        &-partner {
            align-items: center;
            display: flex;
            justify-content: center;

            &-label {
                font-size: 1rem;
                font-weight: 600;
                text-transform: uppercase;

                @media #{$xl-and-up} {
                    font-size: 1.125rem;
                }
            }

            &-name {
                color: $primary-color;
                font-size: 1rem;
                font-weight: 600;
                margin-left: 1.5rem;
                text-transform: uppercase;

                @media #{$xl-and-up} {
                    font-size: 1.125rem;
                }
            }

            &-logo {
                margin-left: 1rem;
                max-height: 50px;
                max-width: 100px;

                @media #{$md-and-up} {
                    margin-left: 1.5rem;
                    max-height: 85px;
                    max-width: 170px;
                }
            }
        }
    }
}
</style>
